import React from 'react';
import Navbar from './Navbar';
import { Toaster } from "@/components/ui/sonner";

export default function Layout({ children }) {
  return (
    <>
      {/* Film grain overlay */}
      <div className="film-grain" />
      
      <div className="min-h-screen bg-background text-foreground">
        <Navbar />
        <main>{children}</main>
      </div>
      <Toaster position="bottom-right" theme="dark" />
    </>
  );
}
